import {useQuery} from "@tanstack/react-query";
import {getAiChatJobs} from "../services/api";
import {createAdapter} from "../components/shared/chat";
import {AiJobsSessionAdapter} from "../components/shared/chat";
import {JobListing} from "../services/types";

export const useAiJobs = (candidateId?: string | number, sessionId?: string, enabled = true) => {
    return useQuery({
        queryKey: ['aiJobs', candidateId, sessionId],
        queryFn: async () => {
            // Guard: Don't call API if sessionId is invalid
            if (!sessionId || typeof sessionId !== 'string') {
                console.warn('useAiJobs: Skipping API call - sessionId is invalid:', sessionId);
                return [];
            }

            const jobs = await getAiChatJobs(sessionId);

            // Transform jobs to JobsListComponent format
            const adapter = createAdapter('aiJobs') as AiJobsSessionAdapter;
            return jobs.map((job: JobListing) => adapter.transformPineconeJob(job));
        },
        enabled: enabled && !!candidateId && typeof sessionId === 'string',
        staleTime: 5 * 60 * 1000, // 5 minutes
        gcTime: 10 * 60 * 1000, // 10 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
};
